import { MembershipPlansProps, stateStatusType } from "./actionType";

export interface FetchMembershipPlanState {
  isLoading: boolean;
  error: string | null;
  membershipPlan: MembershipPlansProps[] | null; // list
  status: stateStatusType | null;
}

export interface GenericMembershipPlanState {
  isLoading: boolean;
  error: string | null;
  status: stateStatusType | null;
  updatedData: MembershipPlansProps | null;
}


export const initalMembershipPlanState: FetchMembershipPlanState = {
  isLoading: false,
  error: null,
  membershipPlan: null,
  status: null,
};

export const initalGenericMembershipPlanState: GenericMembershipPlanState = {
  isLoading: false,
  error: null,
  status: null,
  updatedData: null
};

export interface MembershipPlanState {
  fetchmembershiPlanState: FetchMembershipPlanState;
  genericMembershipPlanState : GenericMembershipPlanState
}

export const initialState: MembershipPlanState = {
  fetchmembershiPlanState: initalMembershipPlanState,
  genericMembershipPlanState:initalGenericMembershipPlanState
}

